import { render } from "./CalculatorLamal.vue?vue&type=template&id=71ae5684&scoped=true"
import script from "./CalculatorLamal.vue?vue&type=script&lang=js"
export * from "./CalculatorLamal.vue?vue&type=script&lang=js"

import "./CalculatorLamal.vue?vue&type=style&index=0&id=71ae5684&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ae5684"]])

export default __exports__